@if ((isOpen && isMobile && (isLoggedIn | async)) || (!isMobile && (isContracted || isExpanded) && (isLoggedIn | async))) {
    <div class="navigation-container d-print-none" [ngClass]="{ isContracted: isContracted, isExpanded: isExpanded, isMobile: isMobile }">
        <div class="navigation">
            <nav role="navigation">
                <ul class="nav flex-column">
                    <!-- Global Search -->
                    @if (!isContracted) {
                        <li class="global-search">
                            <div class="navigation-search">
                                <div class="input-group">
                                    <input
                                        type="text"
                                        class="form-control form-control-sm form-control-xs"
                                        placeholder="{{ 'SEARCH' | translate }}..."
                                        aria-label="Search"
                                        [(ngModel)]="globalSearchVal"
                                        (keyup)="$event.keyCode === 13 && globalSearch()"
                                    />
                                    <button
                                        class="btn btn-sm btn-primary"
                                        [disabled]="!globalSearchVal"
                                        type="button"
                                        id="search-button"
                                        (click)="globalSearch()"
                                    >
                                        <fa-icon icon="search" size="sm"></fa-icon>
                                    </button>
                                </div>
                            </div>
                        </li>
                    }
                    @for (link of links; track link.router) {
                        <li class="nav-item">
                            <!-- No Sublinks -->
                            @if (!link.subLinks) {
                                <div>
                                    @if (link.permission) {
                                        <a
                                            data-zm="nav-link"
                                            class="nav-link {{ link.bgcolorclass }}"
                                            (click)="toggle(!isMobile ? true : false)"
                                            routerLinkActive="active"
                                            routerLink="/{{ link.router }}"
                                        >
                                            <fa-icon [icon]="link.icon" [fixedWidth]="true"></fa-icon><span class="link-name" translate>{{ link.name }}</span>
                                            @if (status && !link.warnings && !link.errors && link.activeCount && status[link.activeCount] > 0) {
                                                <span class="badge badge-warning" (click)="showActiveObjectList(link); $event.preventDefault()">
                                                    {{ status[link.activeCount] }}
                                                </span>
                                            }
                                            @if (link.warnings > 0 && link.errors === 0) {
                                                <span class="badge badge-warning" (click)="showWarningsObjectList(link); $event.preventDefault()">
                                                    {{ link.warnings }}
                                                </span>
                                            }
                                            @if (link.errors > 0) {
                                                <span class="badge badge-danger" (click)="showErrorsObjectList(link); $event.preventDefault()">
                                                    {{ link.errors }}
                                                </span>
                                            }
                                        </a>
                                    }
                                </div>
                            }
                            <!-- Sublinks & Mobile -->
                            @if (link.subLinks && isMobile && link.permission) {
                                <div>
                                    <a
                                        routerLink="/{{ link.router }}"
                                        routerLinkActive="active"
                                        class="nav-link nav-dropdown {{ link.bgcolorclass }}"
                                        (click)="link.isCollapsed = !link.isCollapsed"
                                        [attr.aria-expanded]="!link.isCollapsed"
                                        [attr.aria-controls]="link.name"
                                        ><fa-icon [icon]="link.icon" [fixedWidth]="true"></fa-icon><span class="link-name" translate>{{ link.name }}</span>
                                        @if (!link.isCollapsed) {
                                            <fa-icon class="float-end" icon="angle-down" size="lg"></fa-icon>
                                        }
                                        @if (link.isCollapsed) {
                                            <fa-icon class="float-end" icon="angle-up" size="lg"></fa-icon>
                                        }
                                    </a>
                                    <div [ngbCollapse]="!link.isCollapsed">
                                        <ul class="nav flex-column">
                                            @for (sublink of link.subLinks; track sublink.router) {
                                                <li class="nav-item">
                                                    @if (sublink.permission) {
                                                        <a
                                                            class="nav-link {{ link.bgcolorclass }}"
                                                            routerLinkActive="active"
                                                            routerLink="/{{ sublink.router }}"
                                                            (click)="toggle()"
                                                            translate
                                                            >{{ sublink.name }}</a
                                                        >
                                                    }
                                                </li>
                                            }
                                        </ul>
                                    </div>
                                </div>
                            }
                            <!-- Sublinks & Not Mobile -->
                            @if (link.subLinks && !isMobile && link.permission) {
                                <div>
                                    <a routerLinkActive="active" routerLink="/{{ link.router }}" class="nav-link {{ link.bgcolorclass }}" aria-haspopup="true"
                                        ><fa-icon [icon]="link.icon" [fixedWidth]="true"></fa-icon><span class="link-name" translate>{{ link.name }}</span>
                                        @if (isExpanded) {
                                            <fa-icon class="float-end" icon="caret-right"></fa-icon>
                                        }
                                    </a>
                                    <div>
                                        <ul class="nav dropdown" aria-label="submenu" id="{{ link.name | translate }}">
                                            @for (sublink of link.subLinks; track sublink.router) {
                                                <li class="nav-item">
                                                    @if (sublink.permission) {
                                                        <a
                                                            class="nav-link {{ link.bgcolorclass }}"
                                                            routerLinkActive="active"
                                                            routerLink="/{{ sublink.router }}"
                                                            translate
                                                            >{{ sublink.name }}</a
                                                        >
                                                    }
                                                </li>
                                            }
                                        </ul>
                                    </div>
                                </div>
                            }
                        </li>
                    }
                </ul>
            </nav>
        </div>
    </div>
}
